import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { RedoListItem } from "@redotech/arbiter/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/arbiter/select-dropdown/redo-single-select-dropdown-input";
import { DhlEcsDistributionCenter } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo, useMemo, useState } from "react";

export const DHLCarrierInput = groupInput({
  clientId: input<string>({ validator: nonEmptyValidator }),
  clientSecret: input<string>({ validator: nonEmptyValidator }),
  distributionCenter: input<DhlEcsDistributionCenter>({
    validator: nonEmptyValidator,
  }),
  pickupId: input<string>({ validator: nonEmptyValidator }),
});

export type DHLCarrierValue = InputSchema.Value<typeof DHLCarrierInput>;

export type DHLCarrierForm = InputSchema.Input<typeof DHLCarrierInput>;

export const dhlCarrierDefault = (): DHLCarrierValue => ({
  clientId: "",
  clientSecret: "",
  distributionCenter: DhlEcsDistributionCenter.USORD1,
  pickupId: "",
});

const distributionCenterOptions: RedoListItem<DhlEcsDistributionCenter>[] =
  Object.values(DhlEcsDistributionCenter).map((code) => ({
    id: code,
    type: "text",
    text: code,
    value: code,
  }));

export const CreateDHLCarrierForm = memo(function CreateDHLCarrierForm({
  carrierInput,
}: {
  carrierInput: DHLCarrierForm;
}) {
  const [distributionCenterSearch, setDistributionCenterSearch] = useState("");
  const filteredDistributionCenterOptions = useMemo(
    () =>
      distributionCenterOptions.filter((option) =>
        option.value
          .toLowerCase()
          .includes(distributionCenterSearch.toLowerCase()),
      ),
    [distributionCenterSearch],
  );

  return (
    <>
      <RedoTextInput
        label="Client ID"
        placeholder=""
        setValue={carrierInput.inputs.clientId.setValue}
        value={carrierInput.inputs.clientId.value}
      />
      <RedoTextInput
        label="Client secret"
        placeholder=""
        setValue={carrierInput.inputs.clientSecret.setValue}
        value={carrierInput.inputs.clientSecret.value}
      />
      <RedoSingleSelectDropdownInput
        label="Distribution center"
        options={filteredDistributionCenterOptions}
        optionSelected={({
          item,
        }: {
          item: RedoListItem<DhlEcsDistributionCenter>;
        }) => {
          carrierInput.inputs.distributionCenter.setValue(item.value);
        }}
        searchPlaceholder="Search distribution centers..."
        searchString={distributionCenterSearch}
        selectedItem={distributionCenterOptions.find(
          (option) =>
            option.value === carrierInput.inputs.distributionCenter.value,
        )}
        setSearchString={setDistributionCenterSearch}
      />
      <RedoTextInput
        label="Pickup ID"
        placeholder=""
        setValue={carrierInput.inputs.pickupId.setValue}
        value={carrierInput.inputs.pickupId.value}
      />
    </>
  );
});
